import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import es from "./locales/es.json";
import en from "./locales/en.json";
import fr from "./locales/fr.json";
import it from "./locales/it.json";
import ca from "./locales/ca.json";

export const SUPPORTED_LANGS = [
  { code: "es", label: "ES", name: "Español", flag: "🇪🇸" },
  { code: "en", label: "EN", name: "English", flag: "🇬🇧" },
  { code: "fr", label: "FR", name: "Français", flag: "🇫🇷" },
  { code: "it", label: "IT", name: "Italiano", flag: "🇮🇹" },
  { code: "ca", label: "CA", name: "Català", flag: "🏴󠁥󠁳󠁣󠁴󠁿" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
      fr: { translation: fr },
      it: { translation: it },
      ca: { translation: ca },
    },
    lng: "es",
    fallbackLng: "es",
    supportedLngs: ["es", "en", "fr", "it", "ca"],
    interpolation: { escapeValue: false },
    detection: {
      order: [],
      caches: [],
      lookupLocalStorage: "encantify_lang",
    },
  });

export default i18n;
